
import { Fragment } from 'vue-frag'
import availabilityConstants from '~/store/availability/-constants'

export default {
  name: 'MoleculeAvailabilityProjectFilterResultsDisplay',
  components: {
    Fragment
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    spaceDisplayData() {
      const spaces = [...this.$store.state.availability.space]

      return spaces.sort((a, b) => {
        const getFloorNumber = (floorName) => {
          if (!floorName) return 0
          if (
            floorName.toLowerCase().includes('ground') ||
            floorName.toLowerCase().includes('basement')
          ) {
            return 0
          }
          const match = floorName.match(/\d+/)
          return match ? parseInt(match[0]) : 0
        }

        const floorA = getFloorNumber(a.floor?.name)
        const floorB = getFloorNumber(b.floor?.name)

        return floorA - floorB
      })
    },
    isLoadingData() {
      return this.$store.state.availability.isLoadingData
    },
    hasResults() {
      return this.spaceDisplayData.length > 0
    }
  },
  watch: {},
  mounted() {},
  methods: {}
}
